import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CurrentUserService } from '@smartmoving/sm-shared-lib';
import { LocalDatastoreService } from '@app/core/local-datastore-service';
import { LoggingService } from '@app/core/logging/logging.service';

@Injectable({
  providedIn: 'root'
})
export class AuthRouteGuard implements CanActivate {
  constructor(private readonly currentUser: CurrentUserService,
              private readonly router: Router,
              private readonly localDatastore: LocalDatastoreService,
              private readonly loggingService: LoggingService) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const authenticated = this.currentUser.isAuthenticated();

    if (authenticated) {
      // for convenience, if we're in the browser and we refresh, we need our datastore to re-init our dbs
      const pageRefresh = !this.router.navigated;
      if (pageRefresh) {
        await this.localDatastore.createDbsIfNecessary();
      }
      if (state.url === '/login') {
        await this.router.navigate(['schedule']);
        return false;
      } else {
        this.loggingService.info(`Route changed: ${state.url}`);
        return true;
      }
    } else {
      if (state.url === '/login') {
        return true;
      }
      await this.router.navigate(['login']);
      return false;
    }
  }
}

